import type { EditorPlugin, MountHandler } from '@aha-app/aha-editor-v2';

interface AnchorLinkOptions {
  anchorBaseURL: string;
}

const AnchorLinkPlugin = (options: AnchorLinkOptions): EditorPlugin => {
  const onMount: MountHandler = () => {
    // Scroll to anchors that only appear after editor loads
    if (window.location.hash && window.scrollX === 0 && window.scrollY === 0) {
      window.location.href = window.location.hash;
    }
  };

  return {
    name: 'Anchor link base URL plugin',
    setPluginState: pluginState => {
      pluginState.anchorBaseURL = options.anchorBaseURL;
    },
    handlers: {
      onMount,
    },
  };
};

export default AnchorLinkPlugin;
